import { Component, Input, OnDestroy, OnInit, ViewChild  } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { inArray } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Permission, PermissionUser } from 'src/app/app.models';
import { PermissionUserService } from 'src/app/services/permission-user.service';
import { PermissionService } from 'src/app/services/permission.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RentingService } from 'src/app/services/renting.service';
import { DatePipe } from '@angular/common';
import { AppService } from 'src/app/app.service';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';


@Component({
  selector: 'app-permission-user',
  templateUrl: './permission-user.component.html',
  styleUrls: ['./permission-user.component.scss']
})
export class PermissionUserComponent implements OnInit, OnDestroy {

  //Input
  @Input('idUser') idUser: number;
  rentingGetted: boolean;
  rentingSubscription: Subscription;
  //form
  form: FormGroup;

  displayedColumns: string[] = [
    "id",
    "marque",
    "model",
    "prix",
    "prix_user",
    "date",
    "status"
  ];
  displayedColumns2: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'status', 'date', 'owner', 'actions'];
  displayedColumns3: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'status', 'date', 'lodger', 'actions'];

  currentDate: string | null;
  //subscription
  permissionSubscription: Subscription
  permissionUserSubscription: Subscription;
  dataSource!: MatTableDataSource<any>;
  dataSource2!: MatTableDataSource<any>;
  dataSource3!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  //boolean
  permissionUserCreated: boolean = false;
  resultcat: any;
  rentings: any;

  public permissions: Array<Permission>=[]
  public permissionsUser: Array<PermissionUser>=[]
  public permissionsSave: Array<number>=[]

  currency: string;

  constructor(private permissionService: PermissionService,
              private fb: FormBuilder,
              private rentingService: RentingService,
              public carservice: VehiculeserviceService,
              private datePipe: DatePipe,
              public appService:AppService,
              private permissionUserService: PermissionUserService,
              private toastr: ToastrService) { }

  ngOnInit(): void {

    this.getPermission();

    this.getPermissionUser();
    //console.log(this.idUser);
    this.getCar();
    this.currentDate =  this.datePipe.transform(Date.now(), 'yyyy-MM-dd');
    this.getRenting();
    this.getRenting3();
    this.initForm()

    this.currency = this.appService.getCurrency();

  }

  private initForm() {

    this.form = this.fb.group({
      checkArray: this.fb.array([])
    })

  }

  private getPermission() {

    this.permissionSubscription = this.permissionService.index().subscribe((response: any) => {

      this.permissions = response['permissions'];
    })
  }

  private getPermissionUser()
  {
    this.permissionUserSubscription = this.permissionUserService.index(this.idUser).subscribe((response: any) => {

      this.permissionsUser = response;
      if(this.permissionsUser.length !=0)
      {
        this.permissionsUser.forEach(elt=>{
          this.permissionsSave.push(elt.permission_id);
        })
      }
    })
  }

  onCheckboxChange(e: any) {

    if(e.target.checked)
    {
      if(!this.permissionsSave.find(elt=>elt == e.target.value)) this.permissionsSave.push(Number.parseInt(e.target.value));
    }
    else{
      if(this.permissionsSave.find(elt=>elt == e.target.value))
      {
        let index = this.permissionsSave.findIndex(elt=>elt==e.target.value);;
        this.permissionsSave.splice(index,1);
      }
    }
  }

  public onCheckPermission(id:number):boolean
  {
      return this.permissionsUser.find(perms=>perms.permission_id === id) ? true:false
  }

  

  public getCar() {
    //console.log(this.idCarsUser);
    this.carservice.getallvehicle(this.idUser).subscribe((data: any) => {
      this.resultcat = data;
      //this.idcar = data.id;
      this.dataSource = new MatTableDataSource<any>(this.resultcat);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      console.log(data);
    });
  }

  private getRenting() {

    this.rentingSubscription = this.rentingService.indexLodger(this.idUser).subscribe((rentings: any) => {
     
      this.rentingGetted = true;
      this.rentings = rentings.rentings
      this.dataSource2 = new MatTableDataSource(rentings.rentings);
      this.dataSource2.paginator = this.paginator;
      this.dataSource2.sort = this.sort; 

    });

  }




  private getRenting3() {
    this.rentingSubscription = this.rentingService.indexOwner(this.idUser).subscribe((rentings: any) => {
      this.rentingGetted = true;
      this.rentings = rentings.rentings;
      this.dataSource3 = new MatTableDataSource(rentings.rentings);
      this.dataSource3.paginator = this.paginator;
      this.dataSource3.sort = this.sort;
    });

  }



  
  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'lodger',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  } 

  public viewRenting3(idRenting: number) {
    let renting = this.rentings.find((res: any) => res.id == idRenting);
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'owner',
    }
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');	 
  }


  submitForm() {

    let permissionUser: PermissionUser = {
      'permission_id': this.permissionsSave,
      'user_id': this.idUser
    }
    this.permissionUserSubscription = this.permissionUserService.create(permissionUser).subscribe((response: any) => {
      this.toastr.success("Permission ajouté avec success");
    })
  }

  ngOnDestroy(): void {
    
    this.permissionSubscription.unsubscribe();

    if(this.permissionUserCreated) {

      this.permissionUserSubscription.unsubscribe();

    }

  }

}
